import React, { Component } from 'react';
import store from '../store';
import { RESET_CITY, FILE_IMAGES, typeList, showTimeList, LBFormulaList, LBFormulaList2, answerTimeList, qCountList, maxNumberList, digitsList, YesNoList, typeCatList } from '../config/static';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import DoneIcon from '@material-ui/icons/Done';
import '../style/mycss.css';
import createHistory from 'history/createBrowserHistory';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import * as LHELPER from './LessonHelper';
import InputLabel from '@material-ui/core/InputLabel';
import ButtonBase from '@material-ui/core/ButtonBase';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { Redirect } from 'react-router-dom';
import Numpad from "./Numpad"
import NumDisplay from "./NumDisplay"
import CountDown from "./CountDown"
import firebase from "firebase/app";
import "firebase/firestore";
import * as STATIC from '../config/static';
import _ from 'lodash'
import Modal from 'react-responsive-modal';
const DWIDTH = 915;
const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    backgroundImage: "url('assets/images/bg.jpg')",
    backgroundPosition: "center center",
    backgroundAttachment: "fixed",
    WebkitBackgroundSize: "cover",
    backgroundSize: "cover",
    overflow: 'hidden',
    position: 'absolute',
    display: 'table',
    height: '100%',
    width: '100%',
    color: '#1B5E20'
  },
  middle: {
    display: 'table-cell',
    verticalAlign: 'top',
    padding: "0 5px",
  },
  square: {
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: DWIDTH,
    padding: theme.spacing.unit * 2,
    borderRadius: '20px',
    backgroundColor: '#c5e0b5',
    marginTop: 5,
    marginBottom: 10
  },
  textField: {
    minWidth: 200,

  }, container: {
    maxWidth: "1170px",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "10px"
  }, chips: {
    display: 'flex',
    flexWrap: 'wrap',

  },
  chip: {
    margin: 2,
    backgroundColor: '#538234',
    color: 'white'
  },
});
const defaultSetting = {type:["LB_0"],
times:1,
rows:3,
showTime:6,
answerTime:10,
qCount:10,
maxNumber:10,
digits:1,
digits1:1,
digits2:1,
point:0,
percent:80,
displaySetting:0,
displayShow:0,
lessThan0:0,
largerThan:0,
roundNumber:0,
isReversed:0,
dr1:0,
dr2:0,
dba:1,
ssp:0,
}

function isMobileDevice() {
  return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};
function searchLabel(array, value) {
  let rel = '';
  let index = array.findIndex(a => a.value == value);
  if (index > -1) {
    rel = array[index].label;
  }
  return rel;
}
function isInt(n) { return parseInt(n) === n };
let _this;
class SorobanComp extends Component {
  constructor(props) {
    super(props);
    _this = this;
    this.state = {
      soroban:0,
      showEQ:"",
      questions:[]
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  handleChange = name => event => {

    //event.preventDefault();
    //console.log(event.target.value);
    this.setState({
      [name]: event.target.value

    });

  }
  handleChangeDigits = (name,max) => event => {

    let value = event.target.value;
    if(value>max)
    {
      value=max;
    }

    this.setState({
      [name]: value
    });

  }
  handleChangeNumber = (name,max,min) => event => {
    if(event.target.value>max||event.target.value<1||event.target.value<min)
    {
      return this.forceUpdate();
    }

    this.setState({
      [name]: event.target.value

    });

  }
  handleKeypress = event => {

    if (event.key === "Enter") {
      _this.confirmAnswer();
    }
  }

  handleDelete = (name, value) => {
    let change = _this.state[name];

    change = _.without(change, value);

    this.setState({
      [name]: change
    });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    _this.setState({sAudio:(new Audio("assets/sound/success.mp3")),fAudio:(new Audio("assets/sound/fail2.mp3")),yAudio:(new Audio("assets/sound/yay.mp3"))});

  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }

  onSorobanClick(tArr,index,val)
  {
    //let n1 = parseInt(n)+val;
    tArr[index]=val;
    let newNumber = tArr.join("");
    _this.setState({soroban:parseInt(newNumber)});
  }

  getSorobanImages(numb,width,max=17){
    let tArr = numb.toString().split('');
    //console.log(17-tArr.length);
    if(max<4)
    max=4
    let length = max-tArr.length;
    for(let i=0;i<length;i++)
    {
      tArr.unshift(0);
    }
    let bWidth = width*0.9/max;
    let n=6;
    let bStyle = {width:bWidth,height:bWidth*0.53}
    let rel= (<div style={{display:'flex',flexDirection:'row',border:"1px solid gold"}}>
      {tArr.map((n,index)=>{
        n=parseInt(n);
        return (<div key={index} style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',position:'relative'}}>
        <div>
        <div style={bStyle}>
          <center><b>{n}</b></center>
        </div>
        </div>
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',position:'relative'}}>
        <div style={{position: 'absolute', top: 0,bottom:0,left:0,right:0,justifyContent:'center',display:"flex",alignItems:'center'}}>
          <div

          style={{width: bWidth*0.038,height:'100%',backgroundColor:'green'}} />
      </div>
          <div style={bStyle}>
            {n<5?<ButtonBase onClick={()=>this.onSorobanClick(tArr,index,n+5)}><img
                src="assets/images/soroban/soroban.png"
                style={bStyle} /></ButtonBase>:false}
          </div>
          <div style={bStyle}>
            {n>=5?<ButtonBase onClick={()=>this.onSorobanClick(tArr,index,n-5)}><img
                src="assets/images/soroban/soroban.png"
                style={bStyle} /></ButtonBase>:false}
          </div>
          <div
            style={{position: 'relative',lineHeight:0}}>
            <img
            src="assets/images/soroban/sline.png"
            style={{width: bWidth, height: bWidth*0.11}} />
          {index%3==(tArr.length-1)%3?<div style={{position: 'absolute', top: 0, width: '100%', textAlign: 'center',justifyContent:'center',display:"flex",alignItems:'center'}}>
            <img
            src="assets/images/soroban/dot.png"
            style={{width: 'auto', height: bWidth*0.10}} />
        </div>:false}
            </div>
            <div style={bStyle}>
              {n%5!=0?<ButtonBase onClick={()=>this.onSorobanClick(tArr,index,(n>5?5:0))}><img
                  src="assets/images/soroban/soroban.png"
                  style={bStyle} /></ButtonBase>:false}
            </div>
            <div style={bStyle}>
              {n%5!=1?<ButtonBase onClick={()=>this.onSorobanClick(tArr,index,(n>=5?6:1))}><img
                  src="assets/images/soroban/soroban.png"
                  style={bStyle} /></ButtonBase>:false}
            </div>
            <div style={bStyle}>
              {n%5!=2?<ButtonBase  onClick={()=>this.onSorobanClick(tArr,index,(n>=5?7:2))}><img
                  src="assets/images/soroban/soroban.png"
                  style={bStyle} /></ButtonBase>:false}
            </div>
            <div style={bStyle}>
              {n%5!=3?<ButtonBase   onClick={()=>this.onSorobanClick(tArr,index,(n>=5?8:3))}><img
                  src="assets/images/soroban/soroban.png"
                  style={bStyle} /></ButtonBase>:false}
            </div>
            <div style={bStyle}>{n%5!=4?<ButtonBase  onClick={()=>this.onSorobanClick(tArr,index,(n>=5?9:4))}><img
                src="assets/images/soroban/soroban.png"
                style={bStyle} /></ButtonBase>:false}
            </div>

            </div>

        </div>);
      })}
    </div>);
return rel;
  }
  onStartClick()
  {

    let questions =  LHELPER.randomQuestionList(1,this.props.formular||defaultSetting);
    this.setState({questions},()=>{
      let showEQ = _this.getQuestionEQ(questions[0])+" = ";
      _this.setState({showEQ});
    })
  }
  onAnswerClick()
  {
    let q = _this.state.questions[0];
    let answer = parseFloat(_this.state.soroban);
    if (q.result == answer) {

      if(store.getState().SOUND==1)
      {
        _this.state.sAudio.currentTime=0;
    _this.state.sAudio.play();
      }
    }
    else {
      if(store.getState().SOUND==1)
      {
        _this.state.fAudio.currentTime=0;
  _this.state.fAudio.play();

  }
    }
    this.setState({questions:[],soroban:0,showEQ:(this.state.showEQ+q.result)})
  }
  getQuestionEQ(question)
  {
    let rel = '';
    if(question.type!="image"&&question.type!="soroban")
    {

      for(let num of question.numbers)
      {
        if(question.type!='multiple'&&question.type!='divide')
        {
          if(rel=='')
          {
            rel=num;
            continue;
          }
          else {
            rel += (num>=0?' + ':' - ')+Math.abs(num);
          }
        }
        else {
          if(rel=='')
          {
            rel+=num;
          }
          else {
            rel+=""+num;
          }
        }

      }
    }

    return rel;
  }
  render() {
    const { classes,t,width } = this.props;
    const { wWidth, wHeight,  questions, curIndex,soroban,showEQ} = this.state;

    // if(pWidth)
    // width = pWidth;

    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let setting = this.props.formular||defaultSetting;
    //console.log(setting)
    //console.log("display",displaySetting);
    //console.log(width);
    return (



      <div>
        <Grid container direction="row" justify="center" style={{ paddingBottom:STATIC.calSize(20, STATIC.DWIDTH, width)}}>
          <Grid item xs={12} alignItems="center"
          justify="center" style={{display:'flex'}} >
          {this.state.questions.length==0?<Button onClick={()=>this.onStartClick()} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width),marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#fff", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: 'rgb(0, 104, 56)', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
            {t('common.start')}
          </Button>:false}

          </Grid>
          <Grid item xs={12} >
            <div style={{textAlign:'center',fontSize:fTitle,color: 'rgb(5, 63, 34)'}}>{showEQ}</div>
          </Grid>
          <Grid item xs={12} alignItems="center"
          justify="center" style={{display:'flex'}} >
          {this.state.questions.length>0?<Button onClick={()=>this.onAnswerClick()} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width),marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
            {t('common.answer')}
          </Button>:false}
        </Grid>
          <Grid item xs={12} direction="column"
  alignItems="center"
  justify="center" style={{display:'flex',color: 'rgb(5, 63, 34)'}}>
            <div>
            {this.getSorobanImages(soroban,width,(setting.group=="Multi"||setting.group=="Divide")?17:(setting.digits+2))}
            </div>
          </Grid>

        </Grid>








      </div>


    );
  }
}

SorobanComp.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(STATIC.translate('common')(SorobanComp));
